import React from 'react'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import GoogleMap from '../components/GoogleMap'

export default function Ydelse() {
  const services = [
    {
      icon: 'fa-car',
      title: 'Salg af kvalitetsbiler',
      desc: 'Vi tilbyder et spændende udvalg af brugte kvalitetsbiler til landets absolut bedste priser. Alle biler er klargjorte og kvalitetstjekkede.'
    },
    {
      icon: 'fa-handshake-angle',
      title: 'Køb & vurdering af din bil',
      desc: 'Vi opkøber nyere brugte biler til fair priser. Få en hurtig og professionel vurdering af din nuværende bil i dag.'
    },
    {
      icon: 'fa-file-signature',
      title: 'Kommissionssalg',
      desc: 'Lad os stå for salget af din bil. Vi håndterer hele processen professionelt – fra klargøring og annoncering til prøvekørsel og slutseddel.'
    },
    {
      icon: 'fa-shield-heart',
      title: 'Tryghed & Forsikring',
      desc: 'I samarbejde med Tryg tilbyder vi attraktive bilforsikringer, så du kan køre herfra med fuld ro i maven.'
    }
  ]

  return (
    <>
      <Helmet>
        <title>Ydelse | Recars ApS</title>
        <meta name="description" content="Har du brug for hjælp til denne type opgave? Så læs mere om, hvad vi kan tilbyde her." />
        <meta property="og:title" content="Ydelse | Recars ApS" />
        <meta property="og:description" content="Har du brug for hjælp til denne type opgave? Så læs mere om, hvad vi kan tilbyde her." />
        <link rel="canonical" href="https://recars.dk/ydelse/" />
      </Helmet>

      {/* Header */}
      <section className="relative bg-dark-950 pt-32 sm:pt-40 lg:pt-44 pb-12 border-b border-dark-800">
        <div className="mx-auto max-w-[1600px] px-4 sm:px-6 lg:px-8 xl:px-12 text-left">
          <span className="text-xs font-semibold uppercase tracking-[0.2em] text-[#c5a880]">
            Hvad vi kan tilbyde
          </span>
          <h1 className="mt-2 text-3xl font-bold tracking-tight text-white sm:text-4xl">
            Ydelse
          </h1>
          <p className="mt-4 max-w-2xl text-sm text-slate-400">
            Har du brug for hjælp til denne type opgave? Så læs mere om, hvad vi kan tilbyde her.
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="bg-dark-950 py-20">
        <div className="mx-auto max-w-[1600px] px-4 sm:px-6 lg:px-8 xl:px-12">
          {/* Scraped Contact Block */}
          <div className="rounded-2xl border border-dark-800 bg-dark-900 p-8 text-center max-w-2xl mx-auto mb-16">
            <h3 className="font-display text-lg font-bold text-white uppercase tracking-wider mb-4">
              Kontakt os direkte angående vores ydelser
            </h3>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-6 mt-6">
              <a
                href="tel:+4571999177"
                className="inline-flex items-center gap-2 text-sm font-bold text-[#c5a880] hover:text-[#b39368] transition-colors whitespace-nowrap"
              >
                <i className="fa-solid fa-phone" /> +45 71 99 91 77
              </a>
              <span className="hidden sm:inline text-slate-700">|</span>
              <a
                href="mailto:info@recars.dk"
                className="inline-flex items-center gap-2 text-sm font-bold text-[#c5a880] hover:text-[#b39368] transition-colors whitespace-nowrap"
              >
                <i className="fa-solid fa-envelope" /> info@recars.dk
              </a>
            </div>
          </div>

          {/* Services Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {services.map((service, i) => (
              <div
                key={i}
                className="rounded-2xl border border-dark-800 bg-dark-900 p-8 text-left transition-all duration-300 hover:border-dark-700 hover:scale-[1.01]"
              >
                <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-[#c5a880]/10 border border-[#c5a880]/20 text-[#c5a880] mb-6">
                  <i className={`fa-solid ${service.icon} text-lg`} />
                </div>
                <h3 className="font-display text-lg font-semibold text-white">
                  {service.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-400">
                  {service.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Google Maps Section */}
      <GoogleMap />
    </>
  )
}
